import { useEffect, useState } from 'react';

export const SALES_PREFERENCES_EVENT = 'srm:sales-preferences-changed';
export const SALES_COLUMN_GROUPS = [
  { label: 'Enquiry', keys: ['draft', 'waiting_for_price', 'waiting_customer_confirmation', 'confirmed_waiting_payment', 'paid'] },
  { label: 'Fulfilment', keys: ['completed'], note: 'Purchase and delivery are managed on the Operations page.' },
  { label: 'Side states', keys: ['cancelled'], note: 'Parked is always shown.' },
];
const allowedColumns = new Set(SALES_COLUMN_GROUPS.flatMap(group => group.keys));
allowedColumns.add('customer_reference'); // Optional table field, not a Kanban status.
const storageKey = userId => `srm:sales-preferences:${userId}`;
const clean = value => ({
  soundEnabled: value?.soundEnabled !== false,
  hiddenColumns: Array.isArray(value?.hiddenColumns) ? value.hiddenColumns.filter(key => allowedColumns.has(key)) : [],
  // Customer and supplier chat lists side by side instead of behind tabs.
  dualChatLists: value?.dualChatLists === true,
});
export function loadSalesPreferences(userId) {
  try {
    const saved = userId != null ? localStorage.getItem(storageKey(userId)) : null;
    if (saved) return clean(JSON.parse(saved));
    return clean({ soundEnabled: localStorage.getItem('wati_qv4_sound_enabled') !== 'false', hiddenColumns: JSON.parse(localStorage.getItem('qv4_hidden_cols') || '[]') });
  } catch { return clean(null); }
}
export function saveSalesPreferences(userId, value) {
  if (userId == null) throw new Error('Sign in before saving personal settings.');
  localStorage.setItem(storageKey(userId), JSON.stringify(clean(value)));
  window.dispatchEvent(new CustomEvent(SALES_PREFERENCES_EVENT));
}
export function useSalesPreferences(userId) {
  const [preferences, setPreferences] = useState(() => loadSalesPreferences(userId));
  useEffect(() => {
    const refresh = () => setPreferences(loadSalesPreferences(userId));
    refresh();
    window.addEventListener(SALES_PREFERENCES_EVENT, refresh);
    window.addEventListener('storage', refresh);
    return () => { window.removeEventListener(SALES_PREFERENCES_EVENT, refresh); window.removeEventListener('storage', refresh); };
  }, [userId]);
  return preferences;
}
